import { ROUTE_TO_ACCESS_PAGE } from "./userAccess";

// Lightweight, localStorage-backed list of the user's most recent module
// visits, powering the Home "Recently Used" section. Only the base route and a
// timestamp are stored — no backend endpoint and no new database tables. The
// Home page resolves labels/icons against the Page Master and re-checks RBAC
// before rendering any entry.
const STORAGE_KEY = "hrportal_recently_used";
const MAX_ITEMS = 6;

export function getRecentlyUsed() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(list)) return [];
    return list
      .filter(
        (entry) =>
          entry &&
          typeof entry.route === "string" &&
          typeof entry.visitedAt === "number"
      )
      .slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}

// Record a navigation to a routable Page Master page as the most recent entry.
// Param suffixes (e.g. /candidates/123) are collapsed to the base route so the
// entry always resolves back to a real portal module.
export function recordModuleVisit(pathname) {
  try {
    const first = String(pathname || "").split("/").filter(Boolean)[0];
    const base = first ? `/${first}` : "/";
    if (!base || base === "/") return;
    if (!ROUTE_TO_ACCESS_PAGE[base]) return;
    const next = [
      { route: base, visitedAt: Date.now() },
      ...getRecentlyUsed().filter((entry) => entry.route !== base),
    ].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable / quota exceeded — Recently Used is optional.
  }
}